import React, { Component } from 'react';
import * as Datetime from 'react-datetime';
import moment from 'moment';
import isEqual from 'lodash.isequal';
import Calendar16 from '@carbon/icons-react/lib/calendar/16';
import { DateFormat, TimeFormat, BEDateFormat, BETimeFormat } from './Constants';

export default class DateTimePicker extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(nextProps, this.props);
    }

    renderInput = (props, openCalendar) => {
        return (
            <div className={'bx--date-picker-input__wrapper'}>
                <input
                    {...props}
                    className={"bx--text-input " + (this.props.invalid ? " bx--text-input--invalid" : "") + (this.props.readOnly ? " inputReadOnly" : "")} /* RITM0587358 */
                    disabled={this.props.disabled || false}
                    placeholder={this.props.placeholder || ""}
                    readOnly={this.props.readOnly || false}
                />
                <Calendar16
                    className={`bx--date-picker__icon ${(this.props.readOnly ? "iconReadOnly" : "")}`} /* RITM0587358 */
                    aria-label="Open Calendar"
                    onClick={this.props.disabled ? () => { } : openCalendar}
                    role="img">
                </Calendar16>
            </div>
        );
    }

    validateDate = (inputValue) => {
        const today = moment();
        if(this.props.disableFutureDate) return inputValue.isBefore(today)
        if (this.props.disablePastDate) return inputValue.isAfter(today);

       
        return true
    }

    render() {
        const {
            name,
            alt,
            className
        } = this.props;

        let value = "";
        if (this.props.value) {

            if (this.props.type == "date") {
                value = moment.utc(this.props.value, BEDateFormat);
            } else if (this.props.type == "time") {
                value = moment.utc(this.props.value, BETimeFormat);
            } else {
                value = moment.utc(this.props.value, `${BEDateFormat} ${BETimeFormat}`); //RITM1072295 - Date of DRILL Execution Fix
            }
        }

        const _dateFormat = (this.props.type == "date" || this.props.type == "datetime" || !this.props.type) ? DateFormat : false;
        const _timeFormat = (this.props.type == "time" || this.props.type == "datetime" || !this.props.type) ? TimeFormat : false;

        const _onChange = (value) => {//value substring 3: if < 9 add 0
            if(this.props.type == "time" && typeof value === "string"&& value.length===7){
                const time = moment(value, "h:mm a");   
                 date = time.format(BETimeFormat); 
                 this.props.onChange(name, date, alt);
                 return;            
             }   
            if (!value) {
                this.props.onChange(name, null, alt);
                return;
            }
            try {
                if (!value.isValid()) return;
                var date = '';
                if (this.props.type == "date") {
                    date = value.format(BEDateFormat);
                } else if (this.props.type == "time") {
                    date = value.format(BETimeFormat);
                } else {
                    date = value.format(`${BEDateFormat} ${BETimeFormat}`); //RITM1072295 - Date of DRILL Execution Fix
                }
                this.props.onChange(name, date, alt);
                return;
            }
            catch {
                if (this.props.type == "time" || this.props.type == "datetime") {
                    return this.props.onChange(name, false, alt);
                } else {
                    console.error("_onChange: unsupported type: ", this.props.type);
                    return null;
                }
            }
        };

        return (
            <Datetime
                renderInput={this.renderInput}
                value={value}
                dateFormat={_dateFormat}
                timeFormat={_timeFormat}
                onChange={_onChange}
                className={className || ''}
                closeOnSelect={this.props.type == "date"}
                isValidDate={this.validateDate}
                
               
            />
        );
    }
}